import React from 'react';

import { FileUploadIcon } from './FileUploadIcon';

export const FileUploadOnlyCSVIcon = () => {
  return <FileUploadIcon onlyCsv />;
};
